import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

interface DownloadUpcCSVRequest {
  token: string;
  apiColumnFilters: any;
  apiSorting: any;
}

const downloadUpcCSV = async ({
  token,
  apiColumnFilters,
  apiSorting,
}: DownloadUpcCSVRequest) => {
  try {
    const response = await axios.get(
      `${getBaseUrl(Microservice.WMS)}/wms/inventory/download-upc-csv`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params: {
          columnFilters: apiColumnFilters,
          sorting: apiSorting,
        },
        responseType: "blob",
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);

    throw new Error(message);
  }
};

export default downloadUpcCSV;
